import {
  type DashRouteType,
  URL_APP_ADMIN,
  URL_PUBLIC,
  URL_RETAILER_SCOPED,
} from '@retailer-platform/dashboard/routing'

const URL_SANDBOX = `${URL_RETAILER_SCOPED}/sandbox`
// @hygen:inject scoped-urls

export type DashRouteSet = DashRouteType<'sandbox'>
// @hygen:inject dash-route-set

export const routes: { [Key in DashRouteSet['identifier']]: string } = {
  sandbox: URL_SANDBOX,
  // @hygen:inject route-pair
}

export type DomainRouteName = keyof typeof routes
